import React from 'react';
import { Row, Col, Container, Image } from 'react-bootstrap';
import { Colors } from 'modules/theme';
import { Phone2 } from 'assets/media/images';

const BudgetComponent = () => (
  <Container className="my-5 py-5">
    <Row className="d-flex justify-content-center align-items-center">
      <Col
        xs={12}
        sm={12}
        md={4}
        lg={4}
        className="d-flex justify-content-center align-items-center"
      >
        <Container>
          <h2 style={{ color: Colors.yellowExtra, textAlign: 'left' }}>Your Journey,</h2>
          <h2 style={{ color: Colors.yellowExtra, textAlign: 'left' }}>Simplified</h2>

          <div style={{ marginTop: 24 }}>
            <h5 style={{ textAlign: 'left', lineHeight: '1.7' }}>
              Yieldbucks gives you a clear picture of how you're doing — month by month, decision by
              decision. Track your progress, spot patterns, and stay in control without the
              complexity.
            </h5>
            <ul style={{ marginTop: 20, paddingLeft: 20, listStyle: 'none' }}>
              {[
                'Month-by-month trends at a glance',
                'Know where you stand with your score',
                'Smart guidance when it matters most',
                'Limits that keep your goals on track',
              ].map((item, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 12 }}>
                  <span
                    style={{
                      color: Colors.yellowExtra,
                      marginRight: 10,
                      marginTop: 2,
                      fontWeight: 'bold',
                    }}
                  >
                    —
                  </span>
                  <span style={{ color: '#fff', fontSize: 16, lineHeight: '1.6' }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Container>
      </Col>
      <Col
        xs={12}
        sm={6}
        md={6}
        lg={6}
        className="d-flex justify-content-center align-items-center"
      >
        <Image src={Phone2} width="60%" />
      </Col>
    </Row>
  </Container>
);

export default BudgetComponent;
